import { organizationConstants } from '../constants';

const initialState = {
    loading: false,
    updating: false,
    branding: null,
    error: null,
};

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case organizationConstants.FETCH_BRANDING_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case organizationConstants.FETCH_BRANDING_SUCCESS:
            return {
                ...state,
                loading: false,
                branding: action.branding,
                error: null,
            };
        case organizationConstants.FETCH_BRANDING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case organizationConstants.UPDATE_BRANDING_REQUEST:
            return {
                ...state,
                updating: true,
                error: null,
            };
        case organizationConstants.UPDATE_BRANDING_SUCCESS:
            return {
                ...state,
                updating: false,
                branding: action.branding,
                error: null,
            };
        case organizationConstants.UPDATE_BRANDING_FAILURE:
            return {
                ...state,
                updating: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default organizationReducer;
